import React, { useState } from "react";
import { BigStar, Trash2 } from "../../icons/icons";
import "../../scss/components/StarRating.scss";

const StarRating = ({ handleDone, handleDelete, setRating, rating }) => {
    const [picked, setPicked] = useState(rating);

    const handleClickOutside = () => {
        handleDone();
    };

    const stopProp = (e) => {
        e.stopPropagation();
    };

    return (
        <div className="star-wrapper" onClick={handleClickOutside}>
            <div className="star-done cursor__button" onClick={handleDone}>
                Done
            </div>
            <div className="star-delete cursor__button error" onClick={handleDelete}>
                <Trash2 />
            </div>
            <div className="star-rating" onClick={stopProp}>
                {[1, 2, 3, 4, 5].map((e) => {
                    return (
                        <div
                            onClick={() => setRating(e)}
                            onMouseEnter={() => setPicked(e)}
                            onMouseLeave={() => setPicked(rating)}
                            className={`star-rating__item${
                                picked >= e ? " star-rating__item--picked" : ``
                            }`}
                        >
                            <BigStar />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default StarRating;
